import React from 'react';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import Routes from './router';
import AppProvider from './AppProvider';
import { Loading } from './shared/loading';
import { GlobalStyles } from './globalStyles';
import { RBHModal } from './shared/components';
import { Init } from './Init';
import { RBHTncModal } from './shared/components';

export const App = () => (
  <Provider store={store}>
    <AppProvider>
      <>
        <GlobalStyles />
        <Routes />
        <Init/>
        <RBHTncModal />
        <RBHModal />
      </>
    </AppProvider>
    <Loading />
  </Provider>
);
